// src/utils/pushNotification.js

function urlBase64ToUint8Array(base64String) {
  try {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  } catch (e) {
    console.error("DEBUG: Erro ao converter VAPID Key. Verifique se a chave está correta no .env", e);
    throw e;
  }
}

export async function subscribeUser() { 

  // 1. Verificar Chave
  const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY 

  if (!VAPID_PUBLIC_KEY) return null

  // 2. Verificar Suporte do Navegador
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    console.warn("DEBUG [Erro]: Push API não suportada neste navegador.")
    return null;
  }

  // 3. Aguardar Service Worker  
  let registration
  try {   
    registration = await navigator.serviceWorker.ready  
  } catch (err) {
    console.error("DEBUG [Erro]: Falha ao pegar Service Worker ready:", err)
    return null
  }

  try {
    
    const existingSubscription = await registration.pushManager.getSubscription()
    
    if (existingSubscription) {
      
      return existingSubscription
    }
    
    
    // Converte a chave (pode dar erro aqui se a chave for inválida)
    const convertedKey = urlBase64ToUint8Array(VAPID_PUBLIC_KEY)

    const newSubscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: convertedKey,
    })
   
    return newSubscription

  } catch (err) {
    // ERROS COMUNS CAEM AQUI
    console.error("DEBUG [Erro Fatal]:", err)
    
    if (Notification.permission === 'denied') {
      console.warn("DEBUG: O usuário bloqueou as notificações anteriormente.")
    }
    return null;
  }
}